import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ParentAPIService} from '../parent.api.service';
import {CrystalclearBackUrl} from '../config/crystalclear-back-url';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {TableRequest} from "../../model/api/table-request";

@Injectable({
  providedIn: 'root'
})
export abstract class CommonCrudService<T> extends ParentAPIService implements OnInit, OnDestroy {

  urlConfList: CrystalclearBackUrl.UrlConf<TableRecordResult<T>>;
  urlConfSave: CrystalclearBackUrl.UrlConf<ApiValidation<T>>;
  urlConfDelete: CrystalclearBackUrl.UrlConf<ApiValidation<T>>;

  constructor(http: HttpClient,
              private toastService: ToastService,
              urlConfList_: CrystalclearBackUrl.UrlConf<TableRecordResult<T>>,
              urlConfSave_: CrystalclearBackUrl.UrlConf<ApiValidation<T>>,
              urlConfDelete_: CrystalclearBackUrl.UrlConf<ApiValidation<T>>) {
    super(http);
    this.urlConfList = urlConfList_;
    this.urlConfSave = urlConfSave_;
    this.urlConfDelete = urlConfDelete_;
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public getRecords(request: TableRequest): Observable<TableRecordResult<T>> {
    return this.post(this.urlConfList, request);
  }

  public saveRecord(record: T): Observable<ApiValidation<T>> {
    return this.post(this.urlConfSave, record);
  }

  public deleteRecord(recordIds: string[]): Observable<ApiValidation<any>> {
    return this.post(this.urlConfDelete, recordIds);
  }

}
